// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-1cWZX","modal__footer":"modal__footer-hqO57","modal__footerBtn":"modal__footerBtn-2m4i6","modal_footer_btn_disabled":"modal_footer_btn_disabled-3RK89"};